import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Briefcase } from 'lucide-react';
const roles = [{
  role: 'Senior Executive Vice President',
  org: 'Global Logistics Corp',
  period: '2018 - Present',
  points: ['Spearheaded digital transformation initiative reducing overhead by 22%', 'Managed P&L for $2B division with consistent year-over-year growth', 'Developed strategic partnerships with Fortune 500 suppliers']
}, {
  role: 'Commanding Officer',
  org: 'U.S. Army Logistics Command',
  period: '2014 - 2018',
  points: ['Directed logistics support for 45,000 troops across multiple theaters', 'Oversaw $800M inventory with zero loss accountability', 'Awarded Legion of Merit for exceptional operational efficiency']
}, {
  role: 'Director of Operations',
  org: 'Defense Supply Agency',
  period: '2010 - 2014',
  points: ['Modernized supply chain tracking systems implemented globally', 'Led cross-functional team of 200+ military and civilian personnel', 'Reduced delivery times by 40% through process optimization']
}];
export function ExperienceSection() {
  return <Section id="experience" variant="navy" data-id="element-181">
      <SectionHeader title="Command History" subtitle="Professional Experience" data-id="element-182" />

      <div className="space-y-6" data-id="element-183">
        {roles.map((role, index) => <Reveal key={index} delay={index * 100} data-id="element-184">
            <Card className="flex flex-col md:flex-row gap-6 md:items-start border-l-4 border-l-gold-500" data-id="element-185">
              <div className="md:w-1/4" data-id="element-186">
                <div className="flex items-center gap-2 text-gold-500 mb-2" data-id="element-187">
                  <Briefcase size={18} data-id="element-188" />
                  <span className="font-heading font-bold tracking-wider text-sm" data-id="element-189">
                    {role.period}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white uppercase leading-tight mb-1" data-id="element-190">
                  {role.role}
                </h3>
                <p className="text-slate-400 font-medium" data-id="element-191">{role.org}</p>
              </div>

              <div className="md:w-3/4 border-t md:border-t-0 md:border-l border-white/10 pt-4 md:pt-0 md:pl-6" data-id="element-192">
                <ul className="space-y-3" data-id="element-193">
                  {role.points.map((point, i) => <li key={i} className="flex items-start text-slate-300" data-id="element-194">
                      <span className="text-gold-500 mr-3 mt-1.5 text-xs" data-id="element-195">
                        ■
                      </span>
                      <span data-id="element-196">{point}</span>
                    </li>)}
                </ul>
              </div>
            </Card>
          </Reveal>)}
      </div>
    </Section>;
}